import React, {
    PropTypes,
} from 'react';
import {DateDiapason, CustomSelect} from "../../components";
import {Button} from 'react-bootstrap';

class OrdersHistory extends React.Component {
    static propTypes = {
        ChangeUser: PropTypes.func.isRequired,
        CreateReport: PropTypes.func.isRequired,
        DateDiapasonChange: PropTypes.func.isRequired,
        users: PropTypes.array.isRequired,
        user: PropTypes.object.isRequired,
        begin: PropTypes.object.isRequired,
        end: PropTypes.object.isRequired
    };

    static state = {
        showButton: true
    };

    onToggle(open) {
        this.setState({
            showButton: !open,
        });
    }

    constructor(props) {
        super(props);
        this.state = {showButton: true};
    }


    onUserChange(key) {
        const {users, ChangeUser} = this.props;
        const user = users[key];

        ChangeUser(user.id, user.type, user.fio);
    }

    render() {
        const {users, user, DateDiapasonChange, begin, end, CreateReport} = this.props;

        const userChoice = (
            <CustomSelect
                onToggle={this.onToggle.bind(this)}
                choices={users}
                current={user.id}
                idKey="id"
                emptyValue="Выберите посетителя"
                onChange={this.onUserChange.bind(this)}
                valueKey="fio"
                pic="user"
                className="mb10"
                avatar={(user) => user.photo ?
                    <img className="img-circle" alt={user.fio} width={16}
                         src={"data:image/gif;base64," + user.photo}/> : ''}
            />
        );
        return (
            <div>
                <h3 className="mt5 mb15 text-uppercase" style={{fontWeight: "bold"}}>Замовлення за період – історія</h3>
                {userChoice}
                <DateDiapason
                    begin={begin}
                    end={end}
                    onChange={(b, e) => DateDiapasonChange(b, e)}
                />
                {this.state.showButton ? (<Button
                    block
                    // bsStyle="success"
                    onClick={() => CreateReport(user.id, user.type, begin, end)}
                >Сформувати звіт</Button>) : ''}
            </div>
        );
    }
}

export default OrdersHistory;



/** WEBPACK FOOTER **
 ** ./src/modules/food/OrdersHistory.js
 **/